import {createStore} from 'vuex'
import axiosApi from "@/utils/axiosApi";
// import {Base64} from "js-base64";

export default createStore({
    state: {
        ticketTpl: "",
        rechargeType: "",
        user: {},
        rechargeValue: {},
        rate: 0,
        gsyhLngLat: {},
        gsyhAddress: {},
        pageTongjiToken: "",
        orderFrom: "def",
        qjfToken: ""
    },
    getters: {},
    mutations: {
        getQjfToken(state, value) {
            if (value) {
                window.sessionStorage.setItem("qjfToken", value)
                this.state.qjfToken = value
            } else {
                const qjfToken = window.sessionStorage.getItem("qjfToken");
                this.state.qjfToken = qjfToken || ""
            }
        },
        removeQjfToken() {
            window.sessionStorage.removeItem("qjfToken")
            this.state.qjfToken = ""
        },
        getTicketTpl(state, value) {
            if (value) {
                window.sessionStorage.setItem("ticketTpl", value)
                this.state.ticketTpl = value
            } else {
                const ticketTpl = window.sessionStorage.getItem("ticketTpl");
                this.state.ticketTpl = ticketTpl || "sams"
            }
        },
        getRechargeType(state, value) {
            if (value) {
                window.sessionStorage.setItem("ticketRechargeType", value)
                this.state.rechargeType = value
            } else {
                const recharge = window.sessionStorage.getItem("ticketRechargeType")
                this.state.rechargeType = recharge || "xm_air"
            }
        },
        getUser(state, value) {
            if (value) {
                window.sessionStorage.setItem("userInfo", JSON.stringify(value))
                this.state.user = value
            } else {
                const user = window.sessionStorage.getItem("userInfo")
                this.state.user = JSON.parse(user) || {}
            }
        },
        removeUser() {
            window.sessionStorage.removeItem("userInfo")
            this.state.user = {}
        },
        getRechargeValue(state, value) {
            if (value) {
                window.sessionStorage.setItem("rechargeValue", JSON.stringify(value))
                this.state.rechargeValue = value
            } else {
                const vals = window.sessionStorage.getItem("rechargeValue")
                this.state.rechargeValue = JSON.parse(vals) || {}
            }
        },
        removeTicketTpl() {
            window.sessionStorage.removeItem("ticketTpl")
            this.state.ticketTpl = ""
        },
        getRate(state, playLoad) {
            let rate = window.sessionStorage.getItem(`${playLoad}Rate`)
            if (!rate) {
                new axiosApi({
                    encode: "site",
                    method: "store/rate",
                    body: {mark: playLoad}
                }).send((res) => {
                    if (res.message.code === "000") {
                        window.sessionStorage.setItem(`${playLoad}Rate`, res.data.rate)
                        this.state.rate = parseInt(res.data.rate)
                    }
                })
            } else {
                this.state.rate = parseInt(rate)
            }

        },
        getGsyhLngLat(state, value) {
            if (value) {
                window.sessionStorage.setItem("gsyhLngLat", JSON.stringify(value))
                this.state.gsyhLngLat = value
            } else {
                const lngLat = window.sessionStorage.getItem("gsyhLngLat")
                this.state.gsyhLngLat = JSON.parse(lngLat)
            }
        },
        getGsyhAddress(state, value) {
            if (value) {
                window.sessionStorage.setItem("gsyhAddress", JSON.stringify(value))
                this.state.gsyhAddress = value
            } else {
                const lngLat = window.sessionStorage.getItem("gsyhAddress")
                this.state.gsyhAddress = JSON.parse(lngLat)
            }
        },
        setPageTongjiToken(state, value) {
            let token = window.sessionStorage.getItem("pageToken")
            if (!token) {
                token = setToken()
                token.code = value
                window.sessionStorage.setItem("pageToken", JSON.stringify(token))
            } else {
                token = JSON.parse(token)
                const now = new Date().getTime()
                if (now > token.lastTimer || value !== token.code) {
                    token = setToken()
                    token.code = value
                    window.sessionStorage.setItem("pageToken", JSON.stringify(token))
                }
            }
            this.state.pageTongjiToken = token
        },
        getOrderFrom(){
            this.state.orderFrom = window.sessionStorage.getItem("orderFrom") || "def"
        },
        setOrderFrom(state, value){
            window.sessionStorage.setItem("orderFrom", value)
            this.state.orderFrom = value
        }
    },
    actions: {},
    modules: {}
})

function setToken() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const lastTimer = new Date()
    lastTimer.setHours(lastTimer.getHours() + 2)//有效时长2小时
    return {
        value: Array(32).fill().map(() => characters[Math.floor(Math.random() * characters.length)]).join(''),
        lastTimer: lastTimer.getTime()
    }
}
